import m from "../../../../geodata/es2015/region/world/northAmericaUltra";
window.am4geodata_region_world_northAmericaUltra = m;


//////////////////
// WEBPACK FOOTER
// ./geodata/region/world/northAmericaUltra.js
// module id = null
// module chunks = 